import utilities from '@/helpers/utilities';

export default {
    build() {
        return {
            id: 0,
            acronym: '',
            name: '',
            contract: { id: null },
            contractItem: { id: null },
            office: { id: null },
            description: '',
            contractor: { id: null },
            contractorManager: { id: null },
            priority: { id: 1 },
            isInUse: false,
            isActive: true,
            supplier: { id: null },
            approvers: [],
        };
    },

    toForm(obj) {
        return utilities.toForm(obj, this.build());
    },

    toPayload(obj) {
        return utilities.toPayload(obj);
    },

    // Children
    approver: {
        build() {
            return {
                person: { id: null },
                type: { id: null },
                uuid: utilities.uuidv4(),
            };
        },
    },
};



// WEBPACK FOOTER //
// ./src/helpers/entities/System.js